/* src/app/components/doc-viewer-new/doc-viewer-bottom-right-bar/facts-and-issues-panel/facts-and-issues-panel.component.scss */
.doc-fact {
  background-color: #E4E4E4;
}
:host-context(.dark-theme) .doc-fact,
:host-context(.dark-theme) .doc-fact .mat-mdc-card-content {
  background-color: #424242;
}
.fact-list-item {
  margin-bottom: 8px;
}
.fact-list-item > div {
  border-radius: 4px;
  padding: 6px;
  line-height: 20px;
  background-color: #e3e6ec;
}
:host-context(.dark-theme) .fact-list-item > div {
  background-color: rgba(255, 255, 255, 0.06);
}
label {
  color: #3949AB;
  font-weight: 500;
  display: block;
  margin-bottom: 5px;
}
:host-context(.dark-theme) label {
  color: #FFC107;
}
button {
  background: #FFF;
}
:host-context(.dark-theme) button {
  background: #000;
}
.form-group {
  flex: 1;
}
label {
  display: block;
  margin-bottom: 2px;
}
.icon {
  color: #3949AB;
  --fa-secondary-opacity: 0.5;
}
.single-color-icon {
  --fa-secondary-color: #3949AB;
  --fa-secondary-opacity: 1 ;
}
:host-context(.dark-theme) .icon {
  --fa-primary-color: #FFC107;
  --fa-secondary-color: #6c6c6c;
  --fa-secondary-opacity: 1 ;
}
:host-context(.dark-theme) .single-color-icon {
  --fa-secondary-color: #FFC107;
  --fa-secondary-opacity: 1 ;
}
:host ::ng-deep .mat-mdc-standard-chip {
  background-color: #E4E4E4;
  border-radius: 12px;
  min-height: 18px;
  font-size: 13px;
  font-weight: 300;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:host-context(.dark-theme) .mat-mdc-standard-chip {
  background-color: black;
}
.form-container {
  display: flex;
  flex-direction: column;
}
.form-container > label {
  color: #3949AB;
  font-weight: 500;
  display: block;
  margin-bottom: 2px;
}
:host-context(.dark-theme) .form-container > label {
  color: #FFC107;
}
.input-container {
  display: flex;
  flex-direction: row;
  border: 1px solid #565656;
  border-radius: 5px;
  align-items: center;
  height: 28px;
  outline: transparent solid 0px;
  transition: outline 200ms ease-in-out;
}
.input-container .divider {
  border-right-color: rgba(86, 86, 86, 0.74);
  border-left-color: transparent;
  border-right-width: 1px;
  border-left-width: 1px;
  border-right-style: solid;
  border-left-style: solid;
  transition: border-color 200ms ease-in-out;
}
.input-container:hover {
  border: 1px solid #7a7a7a;
  outline: #7a7a7a solid 1px;
}
.input-container:hover .divider {
  border-color: rgb(122, 122, 122);
}
:host-context(.dark-theme) .input-container:hover {
  border: 1px solid #686868;
  outline: #686868 solid 1px;
}
:host-context(.dark-theme) .input-container:hover .divider {
  border-color: rgb(104, 104, 104);
}
.item-list {
  margin-top: 4px;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 4px;
}
.item {
  background-color: #f1f1f1;
  color: #000;
  border-radius: 5px;
  min-height: 20px;
  width: max-content;
  max-width: 300px;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 12px;
  cursor: pointer;
}
.item .item-text {
  font-size: 13px;
  font-weight: 300;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
:host-context(.dark-theme) .item {
  background-color: #000;
  color: #fff;
}
/*# sourceMappingURL=facts-and-issues-panel.component.css.map */
